import { render, staticRenderFns } from "./taskManage.vue?vue&type=template&id=12db05ce&scoped=true"
import script from "./taskManage.vue?vue&type=script&lang=js"
export * from "./taskManage.vue?vue&type=script&lang=js"
import style0 from "./taskManage.vue?vue&type=style&index=0&id=12db05ce&prod&scoped=true&lang=scss"
import style1 from "./taskManage.vue?vue&type=style&index=1&id=12db05ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db05ce",
  null
  
)

export default component.exports